// Modules
import styled from 'styled-components'

export const StyledHelperButton = styled.div`
    .form__helper-button {
        margin-top: 6px;
        display: flex;
        justify-content: flex-end;
        cursor: pointer;

        span {
            color: #797c86;
            font-size: 12px;
            padding: 4px;
        }
    }
`
